export const ACCOUNT_TYPE_PREVIEW_ROUTE = 'account-type-preview';
export const EMAIL_ACTIVATE_ROUTE = 'activate-email';
export const EMAIL_SENT_ROUTE = 'sent-email';
export const OWNER_DETAILS_ROUTE = 'owner-details';
export const CLAIM_ACCOUNT_ROUTE = 'account/claim-account';
export const OWNER_ADDRESSES_ROUTE = 'owner-address';
export const MEMBERSHIP_OPTIONS_ROUTE = 'membership-options';
export const IDENTIBASE_SUBSCRIBE_APPRECIATION_ROUTE = 'identibase-subscribe-appreciation';
export const ACTIVATE_NO_EMAIL_USER_ROUTE = 'account/activate-no-email-user';
export const QR_CODE_ROUTE = 'qr-code';
export const QR_CODE_PREFERENCES_ROUTE = 'qr-code-preferences';
export const LOGIN_REGISTER_ROUTE = 'login-register';
export const PURINA_ROUTE = 'purina';
export const TOK_CLAIM_ACCOUNT = 'tok-claim-account';
export const TOK_LOGIN = 'tok-login';
export const TOK_PAYMENT = 'tok-payment';
export const TOK_DETAILS = 'tok-details';
